import Home from "./pages/Home";
import ProductList from "./pages/ProductList";
import Product from "./pages/Product";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Cart from "./pages/Cart";
import Success from "./pages/Success"
import Terms from "./pages/Terms";


import { 
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { useSelector } from "react-redux";
import Category from "./pages/Category";



const App = () => {
  const user = useSelector((state) => state.user.currentUser)
  return(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category" element={<Category />} />
        <Route path="/products/:category" element={<ProductList />} />
        <Route path="/product/:id"  element={<Product />} />
        <Route path="/cart"  element={<Cart />} />
        <Route path="/success"  element={<Success />} />
        <Route path="/terms"  element={<Terms />} />
        <Route path="/login"  element={user ? <Navigate to="/" /> : <Login />} />
        <Route path="/register"  element={user ? <Navigate to="/" /> : <Register />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;